<template>
    <div class="brand-feature">
        <div class="section-content flexAlign" style="width: 960px;margin-bottom: 80px;">
              <div class="feature">
                   <div style="color: #fbc200;font-size: 30px;line-height: 36px;">Characteristic of  SHICHIDA education</div>
                   <div style="font-size: 40px;margin: 10px 0px 46px;">七田真的特色</div>
                   <div class="title-h">脑力开发是七田真的特色</div>
                   <p>建立在脑科学基础上的理念</p>
                   <p>专业培养大脑基础认知能力的课程</p>
                   <p>参照大脑发育敏感期的产品</p>
                   <p>应用各类脑科学成果的方法</p>
              </div>
              <div style="width: 400px;"><img src="https://sk-fenxiao.qitianzhen.cn/765x765.png" style="width:90%;"/> </div>

        </div>
        <div class="section-content feature-info" >
            <div style="   display: flex; padding-top: 60px;justify-content: space-around;width:1000px;margin: 0px auto;">
                 <div class="box">
                     <img src="../../assets/imgs/brand/941.png"/>
                     <div class="title-h">专注力</div>
                     <div>专注力是选择性地把资源分配到任务上的能力。</div>
                 </div>
                <div class="box">
                    <img src="../../assets/imgs/brand/942.png"/>
                    <div class="title-h">记忆力</div>
                    <div>记忆力是指识记、 保持、再认识及重现客观事物所反映的内容和经验的能力。 </div>
                </div>
                <div class="box">
                    <img src="../../assets/imgs/brand/945.png"/>
                    <div class="title-h">反应力</div>
                    <div>反应力是指对各种信息、要求和指令做出快速反应的能力。</div>
                </div>
                <div class="box">
                    <img src="../../assets/imgs/brand/943.png"/>
                    <div class="title-h">自控力</div>
                    <div>自控力是指根据环境和目标的要求，克服冲动，抵制诱惑，控制自己的情绪和行为，并根据新的信息迅速调整状态和行为的能力。</div>
                </div>
                <div class="box">
                    <img src="../../assets/imgs/brand/944.png"/>
                    <div class="title-h">思维力</div>
                    <div>思维力是指人们收到信息后，对信息进行归纳、 概括及推理加工的能力。</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return {

            }
        },
        methods:{

        }
    }
</script>
<style lang="less" scoped>
   .brand-feature{
       /*color: #5e5e5e;*/
       /*font-size: 20px;*/
       /*font-family: Light;*/
       .title-h{
           color: #232323;
           font-size: 24px;
           margin-bottom: 10px;
       }
       .feature{
           width: 350px;
           font-weight: 600;
           color: #3e3a39;
           p{
               color: #5e5e5e;
               font-size: 20px;
               font-family: Light;
               text-indent: 24px;
               position: relative;
               &:before{
                   content: '';
                   width: 10px;
                   height: 10px;
                   border-radius: 50%;
                   background-color: #fbc200;
                   position: absolute;
                   top: 10px;
                   left: 0px;
               }
           }
       }

       .feature-info{
           height: 460px;
           background: url("../../assets/imgs/brand/news-bg.png") 100% 100% no-repeat;
           background-size: 100% 100%;
           margin-bottom: 60px;
           color: #3e3a39;
           font-weight: normal;
           font-size: 16px;
           /*padding-bottom: 40px;*/
           .box{
               img{width: 100px;margin: 0px 20px;}
               width: 140px;
               .title-h{
                   text-align: center;
                   margin-bottom: 16px;
               }

           }
       }
   }

</style>
